import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getAllDirectBonification({
    carlotSelected = [],
    stateFilters=[]
}) {
    let query = ''
    
    carlotSelected.forEach(carLot => {
        query = query + `car_lot_id[]=${carLot}&`
    })
    
    stateFilters.forEach((filter)=> {
        query = query + `${filter.keyBackend}[]=${filter.value}&`
    })

    query = query.slice(0, -1)
    const response = await axios(
        `${REACT_APP_API}/bonifications/directa/model?${query}`
    )

    return response?.data?.data || []
}
